module.exports = __webpack_public_path__ + "img/icon-no-start.af3326a3.png";